
      window["APP_BUILD_INFO"] ||= {};
      window["APP_BUILD_INFO"]["contact-us"] = {"build_base_commit_hash":"c309394155d719ee967c94880a06b4d264109d84","build_branch":"release_train_1188666887170","build_pub_date":"2026-07-23 19:54:35","build_version":"2.0.0.702"};
    